import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { MyAddressBookService } from 'src/app/services/feature/kb-My-Address-Book/kb-my-address-book.service';

@Component({
  selector: 'app-addressforemergency-orders',
  templateUrl: './addressforemergency-orders.component.html',
  styleUrls: ['./addressforemergency-orders.component.scss'],
  standalone: false
})
export class AddressforemergencyOrdersComponent {
  isMobile: boolean = false;
  update: any;
  regions: any;
  sub = new Subscription();

  @ViewChild('duplicateAddress') duplicate: any;
  constructor(private breakpointObserver: BreakpointObserver,
    private service: MyAddressBookService,
    private cdr: ChangeDetectorRef,
    private globalMsgService: GlobalMessageService,
    private dialog: MatDialog,
    protected router: Router) {
    this.sub.add(
      this.breakpointObserver
        .observe([Breakpoints.XSmall, Breakpoints.Small])
        .subscribe((result) => {
          this.isMobile = result.matches;
        }));
  }
  pwdchangeForm = new FormGroup(
    {
      companyName: new FormControl(null, [Validators.required]),
      line1: new FormControl(null, [Validators.required]),
      companyAddressTwo: new FormControl(null),
      regionIso: new FormControl(null, { validators: Validators.required }),
      townCity: new FormControl(null, [Validators.required]),
      postcode: new FormControl(null, [Validators.required]),
      countryIso: new FormControl(null, [Validators.required])
    },
  );
  get pwdform() {
    return this.pwdchangeForm.controls;
  }
  ngOnInit() {
    this.sub.add(
      this.service.getAddAddressApi().subscribe((res: any) => {
        this.update = res?.supportedcountries;
        this.cdr.detectChanges();
      }));
  }
  onSubmit() {
    if (this.pwdchangeForm.invalid) {
      const key = 'common.form_global_error';
      this.globalMsgService.add({ key: key }, GlobalMessageType.MSG_TYPE_ERROR);
      this.pwdchangeForm.markAllAsTouched();
    }
    //make Api call
    else {
      this.sub.add(
        this.service.AddAddress(this.pwdchangeForm.value).subscribe((res: any) => {
          if (res) {
            if (res?.message?.status == 'SUCCESS') {
              this.globalMsgService.add({ key: res.message.message }, GlobalMessageType.MSG_TYPE_INFO);
            }
            else if (res?.message?.status == 'ERROR') {
              if (res.showDuplicateAddressError) {
                this.dialog.open(this.duplicate, { maxWidth: '400px', minHeight: '193px' });
              }
            }
          }
        }));
    }
  }
  ngOnDestroy() {
    this.sub.unsubscribe();
  }
  redirector() {
    this.router.navigate(['/address-book']);
  }
  updateState() {
    const iscode = this.pwdform.countryIso.value;
    this.sub.add(this.service.getRegions(iscode).subscribe((res: any) => {
      this.regions = res.regionsWSList;
    }));
  }
}
